import React from 'react'

import { StyledDecorativeInput, StyledInput } from './styles'

const DecorativeInput = ({ value, onChange }) => (
  <StyledDecorativeInput>
    <StyledInput type="text" value={value} onChange={onChange} placeholder="NAME" />
  </StyledDecorativeInput>
)

export default DecorativeInput
